module.exports = __webpack_public_path__ + "geoCompassInverted.bbb407fd8ab150468489c1bd5608a4db.png";